import './Footer.css';

function Footer() {
  return (
    <footer id="contact">
      <div className="ft">
        <div className="fb">
          <a href="#" className="footer-logo">
            <img src="/Impact-your-wealth-Logo_.png.webp" alt="Impact Your Wealth" />
          </a>
          <p>
            Fiduciary financial strategies for high-income individuals who want
            to keep more of what they've earned.
          </p>
        </div>

        <div className="fl">
          <div className="fc">
            <h5>Expertise</h5>
            <a href="#">Roth Conversions</a>
            <a href="#">Long-Term Care</a>
            <a href="#">Life Insurance</a>
            <a href="#">Annuities</a>
          </div>

          <div className="fc">
            <h5>Company</h5>
            <a href="#">About</a>
            <a href="#">Client Stories</a>
            <a href="#">Blog</a>
            <a href="#">Contact</a>
          </div>

          <div className="fc">
            <h5>Legal</h5>
            <a href="#">Privacy Policy</a>
            <a href="#">Disclosures</a>
            <a href="#">Terms</a>
          </div>
        </div>
      </div>

      <div className="fb2">
        <span>
          © 2025 Impact Your Wealth. Investment advisory services.
          Past results do not guarantee future performance.
        </span>
        <a href="mailto:hello@impactyourwealth.com">hello@impactyourwealth.com</a>
      </div>
    </footer>
  );
}

export default Footer;
